/* https://medium.com/@ijlal.tanveer294/how-to-know-if-a-select-dropdown-is-open-555a304e7dda */
import { compositeDisposable, IDisposable } from "../utils/disposable";
import { expressEventListener } from "./html";

export function addOnSelectOpen(selectEl: HTMLSelectElement, onOpen: () => void) {
	let isOpen: boolean;
	const disposable: IDisposable = compositeDisposable([]);
	const setIsOpen = (value: boolean) => {
		isOpen = value;
		if (isOpen && onOpen) onOpen();
	};
	const selectClickHandle = (event: MouseEvent) => {
		if (selectEl) {
			const rect = selectEl.getBoundingClientRect();
			const { clientX, clientY } = event;

			const isInComponent =
				clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;

			if (isInComponent == false) {
				setIsOpen(false);
			}
		}
	};
	const selectBlurHandle = () => {
		setIsOpen(false);
	};

	const selectKeyHandle = (event: KeyboardEvent) => {
		if (event.key === "Enter" || event.keyCode === 13 || event.key === " " || event.keyCode === 32) {
			setIsOpen(true);
		}
	};

	const selectMousePress = () => {
		setIsOpen(!isOpen);
	};

	if (disposable && disposable.addMany) {
		disposable.addMany([
			expressEventListener(selectEl, "click", selectMousePress),
			expressEventListener(selectEl, "blur", selectBlurHandle),
			expressEventListener(selectEl, "keydown", selectKeyHandle),
			expressEventListener(document, "click", selectClickHandle),
		]);
	}

	return {
		dispose: () => disposable && disposable.dispose(),
	};
}
